import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";


export default class Utils {
	constructor() {
		Utils.click();
		Utils.tooltip();
		Utils.fancybox();
		Utils.searchbox();
		Utils.smooth_scroll();
		Utils.lazy();
		Utils.burger();
		Utils.backToTop();
		Utils.SlickLastLaveries();
		Utils.HomeScrollToContent();
		Utils.StickyHeader();
	}

	static click() {

		const trigger = '[data-trigger="wpiris-click"]';

		if (!Modernizr.touchevents) {
			let ctrl = 0;
			$(window).on('keydown', function (e) {
				if (e.which == 17 || e.which == 91) {
					ctrl = true
				}
			})
			$(window).on('keyup', function () {
				ctrl = false
			})

			$(document).on('mouseup', trigger, function (e) {

				if (e.which == 1 || e.which == 2) {
					let blank = false
					let url = $(this).find("a").attr("href")
					if (e.which == 2) {
						blank = true
					} // Clic molette
					if ($(this).find("a").attr("target") == "_blank") {
						blank = true
					}
					if (blank || ctrl) {
						window.open(url, '_blank')
					} else {
						window.location = url
					}
					return false
				}
				return false

			})
		} else {
			$(document).on('click', trigger, function (e) {

				let blank = false
				let url = $(this).find("a").attr("href")
				if ($(this).find("a").attr("target") == "_blank") {
					blank = true
				}
				if (blank) {
					window.open(url, '_blank')
				} else {
					window.location = url
				}
				return false

			})
		}
	}

	static tooltip() {
		if (!Modernizr.touchevents) {
			$('[data-toggle="tooltip"]').tooltip({trigger: "hover"})
		}
	}

	static fancybox() {

		$('.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")').attr('data-fancybox', 'fancybox')

		$('[data-fancybox="fancybox"]').fancybox({
			buttons: [
				"zoom",
				"slideShow",
				"close"
			],
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: Theme.translate.fancyboxClose,
					NEXT: Theme.translate.fancyboxNext,
					PREV: Theme.translate.fancyboxPrev,
					ERROR: Theme.translate.fancyboxError,
					PLAY_START: Theme.translate.fancyboxStart,
					PLAY_STOP: Theme.translate.fancyboxStop,
					FULL_SCREEN: Theme.translate.fancyboxFullScreen,
					THUMBS: Theme.translate.fancyboxThumbs,
					DOWNLOAD: Theme.translate.fancyboxDownload,
					SHARE: Theme.translate.fancyboxShare,
					ZOOM: Theme.translate.fancyboxZoom
				},
			},
			caption: function (instance, item) {
				let caption = $(this).closest('figure').find('figcaption').html()

				if (!caption) {
					caption = $(this).find('img').attr('title')
				}

				if (!caption) {
					caption = $(this).find('img').attr('alt')
				}

				return caption
			}
		})
	}

	static searchbox() {
		const trigger = '[data-trigger="wpiris-search-layout"]',
			close = '[data-trigger="wpiris-search-layout-close"]',
			$element = $('[data-id="wpiris-search-layout"]');

		$(document).on('click', trigger, function (e) {
			e.preventDefault();
			$element.fadeIn().find('input').focus();
		})

		$(document).on('click', close, function (e) {
			e.preventDefault();
			$element.fadeOut();
		})
	}

	static smooth_scroll() {
		const trigger = '[data-trigger="wpiris-scroll"]';

		$(document).on('click', trigger, function (e) {
			e.preventDefault();

			const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href");
			const duration = 1000;

			$('html, body').animate({
				scrollTop: $(target).offset().top
			}, duration);

		})
	}

	static lazy() {
		let lazyLoadInstance = new LazyLoad({
			elements_selector: '[data-src], [data-bg]'
		});
	}

	static burger() {
		const trigger = $('[data-role="trigger-burger"]');

		$(trigger).click(function (e) {
			e.preventDefault();

			if ($('html').hasClass('_nav-open')) {
				$('html').removeClass('_nav-open');
			} else {
				$('html').addClass('_nav-open');
			}
		});

		// Sub menu triggers
		$('.menu li.menu-item-has-children').each(function () {
			let lvl = this;
			let subTrigger = $(this).find('.sub-menu--trigger');

			$(subTrigger).click(function () {
				if ($(lvl).hasClass('_active')) {
					$(lvl).removeClass('_active');
				} else {
					$(lvl).addClass('_active');
				}

			});
		});
	}

	static backToTop() {
		$('.js-backToTop').on('click', function (e) {
			e.preventDefault()

			if ($(window).scrollTop() != 0) {
				$('html, body').animate({scrollTop: 0}, 300)
			}
		})

		$(window).on('scroll', function (e) {

			if ($(this).scrollTop() > 250) {
				$('.js-backToTop').addClass('backToTop--show')
			} else {
				$('.js-backToTop').removeClass('backToTop--show')
			}
		})
	}

	static SlickLastLaveries() {
		const laveriesList = $('.laveriesList--last .laverieList');

		if ($(laveriesList).length) {
			$(laveriesList).slick({
				slidesToShow: 2,
				infinite: false,
				appendArrows: $('.laverieControls'),
				responsive: [
					{
						breakpoint: 1048,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		}
	}

	static HomeScrollToContent() {
		if ($('body').hasClass('home')) {
			const elem = $('.hentry > div:first-child');
			const targetElem = $('.hentry > div:nth-child(2)');

			$('.hentry').append('<div class="scrollToContent"/>');

			if ($(window).scrollTop() > $(elem)) {
				$('.scrollToContent').addClass('hidden');
			}

			$(window).scroll(function () {
				if ($(window).scrollTop() > $(elem).outerHeight()) {
					$('.scrollToContent').addClass('hidden');
				} else {
					$('.scrollToContent').removeClass('hidden');
				}
			});

			$('.scrollToContent').click(function () {
				$('html, body').stop().animate({
					scrollTop: $(targetElem).offset().top
				}, 'slow');
			});
		}
	}

	static StickyHeader() {
		let lastPosition = null;

		let setSticky = function () {
			if ($(window).scrollTop() > $('.header').outerHeight()) {
				$('.headerContainer').addClass('_sticky');
			} else if ($(window).scrollTop() === 0) {
				$('.headerContainer').removeClass('_sticky');
			}
		}

		let getDirection = function () {
			// Force at load
			if (lastPosition == null) {
				lastPosition = $(window).scrollTop();
				return 'top';
			}

			if ($(window).scrollTop() > lastPosition) {
				lastPosition = $(window).scrollTop();
				return 'bottom';
			} else {
				lastPosition = $(window).scrollTop();
				return 'top';
			}
		}

		let setHideShow = function () {
			// Check if scroll to bottom or to top
			if (getDirection() === 'bottom') {
				$('.headerContainer').addClass('_hidden').removeClass('_show');
			} else if (getDirection() === 'top') {
				$('.headerContainer').addClass('_show').removeClass('_hidden');
			}
		}

		// first init
		setSticky();
		setHideShow();
		lastPosition = $(window).scrollTop();

		// On scroll
		$(window).scroll(function () {
			setSticky();
			setHideShow();
		});
	}
}
